import $ from 'jquery';

import { input } from '../../../../../../../component/component'

export default function(o,p,data){

  var id = data.id

  var init = function(){
    div.val(p.filters[id])
  }

  var update = function(){

    var value = div.val()

    if(value){
      p.filters[id] = value
      o.store(p.modelId+'TableFilters',p.filters)
      p.update()

    } else if(p.filters[id]) {
      delete p.filters[id]
      o.store.remove(p.modelId+'TableFilters')
      p.update()

    }
  }

  var div =
    input()
    .css({
      display: 'block',
      width: '50px',
      borderBottom: '1px solid rgba(255,255,255,0.1)',
    })
    .bind('input focus',update)

  init()

  return div;

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/header/column/filter/filter.js